import React, { useState, useEffect} from "react";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import '../App.css';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import {useGlobalState } from "../state";
import Alert from '@mui/material/Alert';
import { Backdrop, CircularProgress } from '@mui/material'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpIcon from '@mui/icons-material/Help';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';


export default function CallExclusionForm() {
    const [loanNumInput, setLoanNumInput] = useState("");
    const [inputArray, setInputArray] = useGlobalState('exclusionInputArray');
    const [editMode] = useGlobalState('editMode')
    const [disableSave, setDisableSave] = useGlobalState('disableSave');
    const [amountErr, setAmountErr] = useGlobalState('amountErr')
    const [exclusionInput, setExclusionInput] = useGlobalState('exclusionInput')
    const [isLoading] = useState(false)
    const [alertModal, setAlertModal] = useGlobalState('alertModal')
    const [errorArray, setErrorArray] = useGlobalState('errorArray')
    const [alreadyExcludedArray, setAlreadyExcludedArray] = useGlobalState('alreadyExcludedArray')

    useEffect(() => {
      if(inputArray.length > 100){
        setDisableSave(true)
        setAmountErr(true)
      } else if(inputArray.length < 100){
        setAmountErr(false)
        setDisableSave(false)
       } 
    });
      
       async function onInputChange(e){
        setLoanNumInput(e.target.value)
        setInputArray(e.target.value.split(','))
        setExclusionInput(e.target.value)
       }
    
      const handleModalClose = () => {
        setAlreadyExcludedArray([])
        setAlertModal(false);
      };


    return (
      <div>
      <Grid size={12}>
     <Typography variant="h6">Call Exclusion Form</Typography>
      <Typography sx={{color:'black'}} variant="subtitle2">Only 100 comma delimited submissions are able to be submitted at once.</Typography>
    <Accordion sx={{ width: "100%", marginBottom:'2%' }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography className="uiSubHeaderFont" id="accordionLabel">
          Call Exclusion
        </Typography>
        <Tooltip
          title="CAF Loan numbers that are excluded from the dialer list no longer fits the dialer requirements for a phone call. "
          sx={{ paddingTop: "0", color: '#febd12' }}
        >
          <IconButton>
            <HelpIcon />
          </IconButton>
        </Tooltip>
      </AccordionSummary>
      <AccordionDetails sx={{ width: "100%" }}>
      <Grid size={12}>   
      <form noValidate autoComplete="off">
      <FormControl sx={{ width: '100%', marginTop:'3%' }}>  
      <TextField
        error= {false}
        disabled={!editMode}
        value={Array.isArray(inputArray) ? inputArray.join(',') : inputArray}
        fullWidth   
        id="standard-textarea"
        label="Enter CAF Loan Number"
        placeholder="Call Exclusion Loan Number Input"
        multiline
        rows={6}
        variant="standard"
        onChange={onInputChange}
          />
      </FormControl>
      </form>
      </Grid>
      </AccordionDetails>
      </Accordion>
      </Grid>
     
      <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
      >
      <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        open={alertModal}
        onClose={handleModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >     
      <Stack sx={{ width: '100%' }} spacing={2}>
      <Alert variant="filled" severity="warning">
      <Typography sx={{color:'white'}} variant="subtitle1">These agreement numbers were not processed. The numbers listed below do not exist or are already excluded. please verify numbers are correct and try again. if problem persists, please contact CCT admin.</Typography>
      </Alert>
      </Stack>  
        <DialogTitle id="alert-dialog-title">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <Typography sx={{color:'black'}} variant="h6">Loan Numbers:</Typography>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
              {errorArray.map((value) => (
               <ListItem
              key={value}
              disableGutters
        >
          <ListItemText sx={{ color: 'black' }} primary={`${value}`} />
          <WarningAmberIcon sx={{color: 'red'}} />
        </ListItem>
      ))}
    </List>
          </DialogContentText>
          {alreadyExcludedArray.length > 0 ?
          <DialogContentText id="alert-dialog-description">
          <Typography sx={{color:'black'}} variant="h6">These loan numbers were already excluded:</Typography>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
              {alreadyExcludedArray.map((value) => (
               <ListItem
              key={value}
              disableGutters
        >
          <ListItemText sx={{ color: 'black' }} primary={`${value}`} />
          <WarningAmberIcon sx={{color: 'red'}} />
        </ListItem>
      ))}
    </List>
          </DialogContentText>
          : ""}          
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} autoFocus>
            Return To Exclusion Form
          </Button>
        </DialogActions>
      </Dialog> 
      </div>
    )
}
